import { apiClient } from './config';

/**
 * Optimize traffic phases
 */
export const optimizePhases = async (data) => {
  const response = await apiClient.post('/optimize', data);
  return response.data;
};

/**
 * Create conflitti for workflow
 */
export const createConflitti = async (data, workflow_id) => {
  const response = await apiClient.post(`/conflitti/${workflow_id}`, data);
  return response.data;
};

/**
 * Calculate green wave (Onda Verde)
 */
export const calculateGreenWave = async (data) => {
  const response = await apiClient.post('/calcola_onda_verde', data);
  return response.data;
};

/**
 * Calculate traffic capacity
 */
export const calculateCapacity = async (data) => {
  const response = await apiClient.post('/calculate_capacity', data);
  return response.data;
};
